import { updateUserPassword } from '../services/userService'

function fetchUpdatePassword(data) {
  return () => updateUserPassword(data)
}

export default fetchUpdatePassword



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchUpdatePassword.js